import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiRequestPin = ({ queryParams }) => apiRequest({
  url: 'api/requestPin',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }

  return {
    parsedData: response?.data?.data,
  };
});

export const apiRequestPinInApp = ({ queryParams }) => apiRequest({
  url: 'api/requestPinInApp',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }
});

export const apiVerifyPin = ({ queryParams }) => apiRequest({
  url: 'api/verifyPin',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }
});

export const apiVerifyPinInApp = ({ queryParams }) => apiRequest({
  url: 'api/verifyPinInApp',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum || response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: responseEnum });
  }
});

// EVINA/DCBProtect antifraud (Iraq/Zain): same-origin proxy to the getScript call. The backend fetches
// the probe server-side (the browser cannot - the partner host has a self-signed cert), and returns
// { s: '<script>' } (empty s when no probe was issued). Returns the raw body so the caller reads data.s.
export const apiGetAntifraudScript = ({ queryParams }) => apiRequest({
  url: 'api/getAntifraudScript',
  method: 'GET',
  params: queryParams,
}).then((response) => response?.data);

export const apiReoptin = () => apiRequest({
  url: 'api/reoptin',
  method: 'GET',
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }
});

export const apiOptoutApiCall = () => apiRequest({
  url: 'api/optout',
  method: 'GET',
});

export const apiVerifyReoptinPin = ({ payload }) => apiRequest({
  url: 'api/verifyReoptinPin',
  method: 'POST',
  data: payload,
}).then((response) => {
  return {
    responseEnum: response?.data?.responseEnum,
  };
});

export const apiGetStatusForBrainiac = ({ queryParams }) => apiRequest({
  url: 'api/getStatusForBrainiac',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }

  return {
    parsedData: response?.data?.data,
  };
});

export const apiGetStatusVerificationPin = ({ queryParams }) => apiRequest({
  url: 'api/getStatusVerificationPin',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }
});

export const apiSendFriendInvitation = ({ payload }) => apiRequest({
  url: 'api/sendFriendInvitation',
  method: 'POST',
  data: payload,
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }
});
